import { environment } from '../../environments/environment';

export const API_BASE_URL = environment.brands.enelx.baseUrl;

export const DEFAULT_HTTP_OPTIONS = {
  withCredentials: true,
};

export const API_TIMEOUT_MS = 10000; // Aborts the HTTP call after API_TIMEOUT_MS (default: 10s)
export const API_RETRY_COUNT = 1; // Retries failed requests up to API_RETRY_COUNT times

export function buildUrl(path: string): string {
  return `${API_BASE_URL.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}
